module.exports = __webpack_public_path__ + "static/media/my-pic.4d4ea0ed.jpg";